import { useEffect, useState } from "react";
import API from "../../services/API/CRM";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import { Link } from "react-router-dom";
import { Link as A, Stack, Typography} from "@mui/material";
import moment from "moment";
import Chip from "../Tools/Chip";
import { Check, Close } from "@mui/icons-material";

export default function EventActivities(){
    
    const columns = [
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 160,
            type: 'date',
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated  &&
                moment(p.row.createdAt).format('DD/MM/YYYY à HH:mm'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'person',
            headerName: 'Contact',
            width: 200,
            type: 'string',
            valueGetter: p => p.row.user?.name,
            renderCell: p => !p.rowNode.isAutoGenerated  &&
                <Link to={`/crm/persons/${p.row.user?.id}`}>
                    <A component='span'>
                        {p.row.user?.name}    
                    </A>
                </Link>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'kind',
            headerName: 'Type de contact',
            width: 120,
            type: 'string',
            valueGetter: p => p.row.user?.kind,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 155,
            valueGetter: p => p.row.category?.title,
            renderCell: p => !p.rowNode.isAutoGenerated  &&
                <Stack direction='row' spacing={1} alignItems='center'>
                    <Chip color={p.row.category?.color} size={14}/>
                    <Typography variant='span'>{p.value}</Typography>
                </Stack>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'events',
            headerName: 'Tags',
            width: 250,
            type: 'string',
            valueGetter: p => p.row.eventsText,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'note',
            headerName: 'Note',
            width: 300,
            type: 'string',
            valueGetter: p => p.row.note,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'won',
            headerName: 'Converti',
            width: 80,
            type: 'boolean',
            valueGetter: p => p.row.won ? true : false,
            renderCell: p => !p.rowNode.isAutoGenerated  ?
                (p.value ? <Check color='primary'/> : <Close color='error'/>) : 
                false,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'winsAmount',
            headerName: 'CA',
            width: 80,
            type: 'number',
            valueGetter: p => p.row?.winsAmount || 0
        },
        {
            field: 'createdBy',
            headerName: 'Créé par',
            width: 200,
            type: 'string',
            valueGetter: p => p.row.createdBy?.name,
            aggregable: false,
            groupable: false,
        },
    ];


    const [items, setItems] = useState(null)

   
    useEffect(() => {

        API.getEventActivities()
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }, [])



    return <Layout tab='events' menu='crm' title='Suivi client'>

        <Grid 
            id='eventActivitiesGrid23101801'
            columns={columns}
            rows={items}
            toolbar
            aggregate={{winsAmount: 'sum'}}
        />

    </Layout>

}


